import React from 'react'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'

type QuerySummaryProps = {
  data: { header: string; value: string }[]
  maxHeight?: 'sm' | 'md'
  minItems?: number
  disableShowMore?: boolean
}

export const QuerySummary = (props: QuerySummaryProps) => {
  const { data, maxHeight = 'md', minItems = 2, disableShowMore = false } = props
  const [open, setOpen] = React.useState(false)

  const result = data.filter((item) => item.value)
  const getValue = (value: string, maxLength?: number) => {
    if (value) {
      const valueArray = value.split(', ')
      const filteredValueArray = valueArray.filter((item, index, self) => index < (maxLength ?? self.length))

      return valueArray.includes('all')
        ? 'All'
        : `${filteredValueArray.join(', ')}${valueArray.length > filteredValueArray.length ? '...' : ''}`
    }
    return ''
  }

  const getMaxHeight = () => {
    return maxHeight === 'sm' ? 'max-h-72' : maxHeight === 'md' ? 'max-h-96' : ''
  }

  return (
    <div className={`w-full mt-6 bg-gray-100 rounded-md`}>
      <section className="flex flex-col p-4">
        <div className={`overflow-y-auto ${getMaxHeight()}`}>
          <div className="flex flex-col md:flex-row md:flex-wrap">
            {result.map((item, index, arr) => (
              <div
                key={item.header + '-' + item.value}
                className={`flex flex-1 flex-col pr-10 mr-4 ${
                  index !== arr.length - 1 ? 'border-r-2' : 'border-r-2 md:border-r-0'
                }`}
              >
                <h1 className="text-lg font-semibold"> {item.header} </h1>
                {(open || minItems > 0) && (
                  <span className="text-lg">{getValue(item.value, open ? undefined : minItems)}</span>
                )}
              </div>
            ))}
          </div>
        </div>
        {!disableShowMore && (
          <div className="flex justify-center">
            {open ? (
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => {
                  setOpen(false)
                }}
              >
                <RemoveCircleOutlineIcon />
                <span>Show Less</span>
              </div>
            ) : (
              <div
                className="flex items-center gap-2 cursor-pointer"
                onClick={() => {
                  setOpen(true)
                }}
              >
                <AddCircleOutlineIcon />
                <span>Show More</span>
              </div>
            )}
          </div>
        )}
      </section>
    </div>
  )
}
